import { get, post, put } from "./http.service";

const LandService = {
  addLand: (body, langCode) => post(`land?langCode=${langCode}`, body),
  getLandById: (id, langCode) => get(`land/${id}?langCode=${langCode}`),
  updateLandById: (id, body, langCode) => put(`land/${id}?langCode=${langCode}`, body),
  updateAuditStatus: (id, body) => put(`land/updateAuditStatus/${id}`, body),
  updatePropertyWithBynderDATUrls: (id, body) => post(`bynder/${id}`, body),
};
export default LandService;
